// --- Core ---
import {ReactElement} from "react";
import {FieldRenderProps} from "react-final-form";
// --- Material UI ---
import {FormControl, FormHelperText, InputLabel, Select, SelectProps} from "@mui/material";

interface SelectFieldProps {
  children: ReactElement[];
  label: ReactElement;
  required?: boolean;
}

export const SelectField = <T, >({
  input,
  label,
  required,
  meta: {touched, invalid, error, submitError},
  children,
  ...props
}: FieldRenderProps<T, HTMLInputElement> & SelectFieldProps & SelectProps) => (
    <FormControl
      fullWidth variant="outlined"
      error={touched && invalid}
  >
    <InputLabel
        variant="outlined"
        id={`${input.name}_label`}
        required={required}
      >
        {label}
      </InputLabel>
    <Select
        {...input}
        labelId={`${input.name}_label`}
        label={label}
        error={touched && invalid}
        {...props}
      >
        {children}
      </Select>
    {
        touched && (error || submitError) &&
        <FormHelperText>
          {error || submitError.join(", ")}
        </FormHelperText>
      }
  </FormControl>
  );


export const SelectFieldWithoutText = <T, >({
  input,
  required,
  meta: {touched, invalid},
  renderValue,
  children,
  ...props
}: FieldRenderProps<T, HTMLInputElement> & SelectFieldProps & SelectProps) => (
  <Select
      {...input}
      labelId={`${input.name}_label`}
      required={required}
      displayEmpty
      renderValue={(selected) => renderValue(selected)}
      error={touched && invalid}
      {...props}
      variant="standard"
      disableUnderline
      sx={
        {
          "& .MuiSelect-select": {
            p: 0, // kein Padding
            display: "flex",
            alignItems: "center"
          },
          "& fieldset": {border: "none"}
        }
      }
    >
      {children}
    </Select>
  );
